import {useDispatch} from 'react-redux';
import {useCallback, useMemo} from 'react';
import {showMessageAction} from '../store/ui/actions';

export function useMessage() {
    const dispatch = useDispatch();
    const warning = useCallback((message: string, closable = true) => {
        dispatch(showMessageAction('warning', message, null, closable));
    }, [dispatch]);
    const failure = useCallback((message: string, closable = true) => {
        dispatch(showMessageAction('failure', message, null, closable));
    }, [dispatch]);
    const success = useCallback((message: string, closable = true) => {
        dispatch(showMessageAction('success', message, null, closable));
    }, [dispatch]);
    const info = useCallback((message: string, closable = true) => {
        dispatch(showMessageAction('info', message, null, closable));
    }, [dispatch]);
    const loading = useCallback((message: string, closable = true) => {
        dispatch(showMessageAction('loading', message, null, closable));
    }, [dispatch]);

    return useMemo(() => ({failure, success, info, loading, warning}), [failure, info, success, loading, warning]);
}
